import { FC, createElement } from 'react';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import classes from 'src/styles/_commonClasses.module.scss';
import {
  Content,
  Title,
  WebpImage,
} from 'components/Shared/SharedComponents';

import styles from './CustomizableMobileSlider.module.scss';

import type { ListBlockProps } from '../config/declarations';

const richTextConfig = {
  [BLOCKS.HEADING_3]: {
    classNames: styles.title,
  },
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.paragraph,
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
};

export const ListBlock: FC<ListBlockProps> = ({ block, tag = 'li' }) => {
  if (!block) {
    return null;
  }

  const { richTitle, content, image } = block;

  return createElement(
    tag,
    { className: styles.block },
    <>
      {image && (
        <WebpImage
          image={image}
          className={styles.image}
        />
      )}
      <Title richText={richTitle} config={richTextConfig} />
      <Content richText={content} config={richTextConfig} />
    </>,
  );
};
